var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLaptopCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 27V21M5 27V11C5 7.22876 5 5.34315 6.17157 4.17157C7.34315 3 9.22876 3 13 3H20",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99524 29.0309L5.03906 27H36.9036L38.0046 29.0309C40.8903 34.3539 41.6092 37.0154 40.5123 39.0077C39.4154 41 36.5072 41 30.6908 41L11.3092 41C5.49283 41 2.58463 41 1.48774 39.0077C0.390854 37.0154 1.10949 34.3539 3.99524 29.0309Z",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10.3333C23 12.9107 25.0147 15 27.5 15H36.95C39.1868 15 41 13.1196 41 10.8C41 8.4804 39.1868 6.6 36.95 6.6C36.9101 6.6 36.95 1 32 1C29.4109 1 27.2861 3.06138 27.0684 5.68786C24.7856 5.91313 23 7.90699 23 10.3333Z",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaptopCloud);
export default __webpack_public_path__ + "static/media/IconLaptopCloud.952e13fc3ec54f1fe1f0e1dfbf85ba0f.svg";
export { ForwardRef as ReactComponent };